












import { Component, Prop, Vue } from 'vue-property-decorator';
import ExtLink from '@/components/ext/Link.vue';

@Component({
  components: { ExtLink },
})
export default class PageProfileOrders extends Vue {
  @Prop({ type: Array, default: () => [] })
  items: Array<any>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/sort/component.vue